<template lang="pug">
  v-card.px-2(flat @click="clickEdit")
    v-row(no-gutters)
      v-col.py-1.shrink
          v-img.ma-2(:src="product.image ? product.image.file : require('@/assets/image_placeholder.png')" width="88px" aspect-ratio="1")
            div.d-flex.justify-center.align-end(style="height: 100%" v-if="product.inventory_enabled")
              v-chip.white--text.mb-2(x-small color="primary500") {{ getProductCount() }}
      v-col.py-3.pr-2
        div.p1.basic800--text.mb-1 {{ product.name }}
        div.c2.basic600--text.product-description.mb-1 {{ product.total_items }} {{ product.total_items > 1 ? 'items' : 'item' }}
        div.c2.basic600--text.mb-1 {{ product.price | displayPrice }}
        div.c1.basic700--text {{ $t('redeemed') }}: {{ product.total_redeemed }}
      v-col.shrink.py-3(@click.stop v-if="member.role === 'Admin'")
        div(style="height: 50%")
          y-switch.mr-2(v-if="Auth('component', '/admin/offers#product_bundle')" v-model="status")
          y-switch.mr-2(v-else v-model="showSubscribe")
        div.d-flex.justify-end.align-end(style="height: 50%")
          v-menu(left :offset-x='true')
            template(v-slot:activator="{ on, attrs }")
              v-btn.mr-2(icon v-on="on")
                v-icon(color="basic700") mdi-dots-vertical
            v-list
              v-list-item(@click="clickEdit")
                v-list-item-title.s2.basic800--text {{ $t('edit') }}
              v-list-item(@click="clickDelete")
                v-list-item-title.s2.basic800--text {{ $t('delete_bundle') }}

    .modals
      add-bundle(v-if="openAddBundleDialog" :open.sync="openAddBundleDialog" :parentProduct="product" @edited="$emit('edited', $event)")
      y-dialog(v-if="openDeleteDialog" v-model='openDeleteDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('delete_bundle') }}
          v-card-text.p2.primary500--text.px-4
            div {{ $t('delete_bundle_confirmation') }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openDeleteDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='danger500' depressed height=32 @click='startDelete' :loading="isLoading" dark)
              .button-AA-small.basic100--text {{ $t('delete') }}

</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import AddBundle from '@/components/offers/dialogs/bundles/AddBundle.vue'
import ShowMoreText from '@/components/ShowMoreText.vue'

export default {
  name: 'BundleItem',
  props: {
    parentBundle: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { AddBundle, ShowMoreText },
  data: () => ({
    openAddBundleDialog: false,
    showDuplicateProductDialog: false,
    openDeleteDialog: false,
    isLoading: false,
    showSubscribe: false
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({
      company: 'getCompany'
    }),
    product() {
      return this.parentBundle
    },
    status: {
      set(val) {
        this.updateProductStatus(val)
      },
      get() {
        if (this.product.status === 'published') {
          return true
        } else {
          return false
        }
      }
    }
  },
  watch: {
    showSubscribe () {
      this.$emit('openSubscription')
      this.falsingShowSubscribe()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    getProductCount() {
      if (this.product.inventory_qty > 99) {
        return '99+'
      }
      return this.product.inventory_qty.toString()
    },
    clickEdit() {
      if (this.member.role !== 'Admin') {
        return
      }
      this.openAddBundleDialog = true
    },
    clickDelete() {
      this.openDeleteDialog = true
    },
    startDelete() {
      this.isLoading = true
      this.axios
        .patch(`/products/${this.product.id}/`, { deleted: true })
        .then(() => {
          this.$emit('deleted', this.product)
          this.openDeleteDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    updateProductStatus(val) {
      let status = ''
      let word = ''
      if (val) {
        status = 'published'
        word = 'Bundle published successfully.'
      } else {
        status = 'draft'
        word = 'Bundle changed to draft'
      }
      this.$axios
        .patch(`/products/${this.product.id}/`, { status: status })
        .then(() => {
          this.showMessage(['success', word])
          this.$emit('status', status)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    falsingShowSubscribe () {
      setTimeout(() => {
        this.showSubscribe = false
      }, 500)
    }
  }
}
</script>

<style scoped>
/* .count-layout {
  position: absolute;
  right: 10px;
  top: 6px;
} */

.product-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>

<i18n>
{
  "en": {
    "delete_bundle": "Delete Bundle",
    "delete_bundle_confirmation": "Are you sure you want to delete this item? This item will be deleted permanently.",
    "redeemed": "Redeemed"
  },
  "id": {
     "delete_bundle": "Hapus Bundle",
    "delete_bundle_confirmation": "Anda yakin ingin menghapus item ini? Item ini akan dihapus secara permanen.",
    "redeemed": "Telah Ditebus"
  }
}
</i18n>